<div class="ofwca-to-register-list-container">
  <div fxLayout="column" fxLayoutGap="15px">

    <div fxLayout="row" fxLayoutGap="15px">
      <button *ngIf="meetingObject.type.key !== MEETING_TYPE_NEW_AGENT_TRAINING " mat-stroked-button [class.spinner]="processingRequest" [disabled]="processingRequest || !(userPermissions | async).meeting.read_and_sign_up" (click)="registerOfwcas()"><mat-icon>save</mat-icon> Zapisz na {{meetingObject.type.name}}</button>
      <button *ngIf="meetingObject.type.key === MEETING_TYPE_NEW_AGENT_TRAINING " mat-stroked-button [class.spinner]="processingRequest" [disabled]="processingRequest || !(userPermissions | async).meeting.read_and_sign_up" (click)="registerOfwcasActive()"><mat-icon>save</mat-icon> Zapisz na {{meetingObject.type.name}}</button>
      <span fxFlex></span>
      <button *ngIf="meetingObject.type.key !== MEETING_TYPE_NEW_AGENT_TRAINING " mat-stroked-button (click)="selectAll()"><mat-icon>done</mat-icon> Zaznacz wszystkie</button>
      <button *ngIf="meetingObject.type.key !== MEETING_TYPE_NEW_AGENT_TRAINING " mat-stroked-button (click)="unselectAll()"><mat-icon>rule</mat-icon> Odznacz wszystkie</button>
      <button *ngIf="meetingObject.type.key === MEETING_TYPE_NEW_AGENT_TRAINING " mat-stroked-button (click)="selectAllActive()"><mat-icon>done</mat-icon> Zaznacz wszystkie</button>
      <button *ngIf="meetingObject.type.key === MEETING_TYPE_NEW_AGENT_TRAINING " mat-stroked-button (click)="unselectAllActive()"><mat-icon>rule</mat-icon> Odznacz wszystkie</button>

    </div>

    <div fxLayout="row">
      <app-dict-ofwcas fxFlex="350px" [multiple]="false" label="OFWCA" [control]="ofwcaControl"></app-dict-ofwcas>
    </div>

    <div *ngIf="meetingObject.type.key === MEETING_TYPE_EXAM || meetingObject.type.key === MEETING_TYPE_ENTRANCE_EXAM">
      <table mat-table [dataSource]="ofwcaDataSource">

        <ng-container matColumnDef="ofwca">
          <th mat-header-cell *matHeaderCellDef> OFWCA </th>
          <td mat-cell *matCellDef="let element">
            <a class="default-link" [routerLink]="['/ofwca/szczegoly', element?.registration?.ofwca?.uuid]">
              {{element?.registration?.ofwca?.fullName}}
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="activeKrk">
          <th mat-header-cell *matHeaderCellDef> Aktywne KRK </th>
          <td mat-cell *matCellDef="let element" class="center-cell">
            <button *ngIf="element.registration.ofwca?.hasActiveKrk" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
            <button *ngIf="!element.registration.ofwca?.hasActiveKrk" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
            <ng-container *ngIf="element.registration.ofwca.hasActiveKrk">({{element.registration.ofwca.krkActiveTo | daysDiff}}&nbsp;dni)</ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="livingAddress">
          <th mat-header-cell *matHeaderCellDef> Adres zamieszkania </th>
          <td mat-cell *matCellDef="let element">
            <app-table-address [address]="$any(element.registration.ofwca?.livingAddress)"></app-table-address>
          </td>
        </ng-container>

        <ng-container matColumnDef="facilityAddress">
          <th mat-header-cell *matHeaderCellDef> Adres placówki </th>
          <td mat-cell *matCellDef="let element">
            <app-table-address [address]="$any(element.registration.ofwca?.facility?.address)"></app-table-address>
          </td>
        </ng-container>

        <ng-container matColumnDef="partner">
          <th mat-header-cell *matHeaderCellDef> Partner </th>
          <td mat-cell *matCellDef="let element">
            <a *ngIf="element.registration.contract?.partner" class="default-link"
               [routerLink]="['/partnerzy/szczegoly', element.registration.contract?.partner?.uuid]">{{element.registration.contract?.partner?.shortName}}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="assetsRegional">
          <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) OFWCA</th>
          <td mat-cell *matCellDef="let element">
            {{element.registration.ofwca?.assetsRegional?.fullName}}
          </td>
        </ng-container>
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef> Data dodania wniosku o rejestrację</th>
          <td mat-cell *matCellDef="let element">
        {{element.registration.createdAt | date:'y-MM-dd'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="partnerAssetsRegional">
          <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
          <td mat-cell *matCellDef="let element">
            {{element.registration.ofwca?.partner?.assetsRegionalFullName}}
          </td>
        </ng-container>

        <ng-container matColumnDef="checkbox">
          <th mat-header-cell *matHeaderCellDef> Zapisz na egzamin </th>
          <td mat-cell *matCellDef="let element">
            <mat-slide-toggle (change)="disableAboveLimit()" [formControl]="element.checkbox" label=""></mat-slide-toggle>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
    </div>

    <div *ngIf="meetingObject.type.key === MEETING_TYPE_IDD_TRAINING">
      <table mat-table [dataSource]="ofwcaDataSource">

        <ng-container matColumnDef="ofwca">
          <th mat-header-cell *matHeaderCellDef> OFWCA </th>
          <td mat-cell *matCellDef="let element">
            <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.iddTraining?.ofwca.uuid]">
              {{element.iddTraining?.ofwca.fullName}}
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="livingAddress">
          <th mat-header-cell *matHeaderCellDef> Adres zamieszkania </th>
          <td mat-cell *matCellDef="let element">
            <app-table-address [address]="$any(element.iddTraining?.ofwca?.livingAddress)"></app-table-address>
          </td>
        </ng-container>

        <ng-container matColumnDef="facilityAddress">
          <th mat-header-cell *matHeaderCellDef> Adres placówki </th>
          <td mat-cell *matCellDef="let element">
            <app-table-address [address]="$any(element.iddTraining?.ofwca?.facility?.address)"></app-table-address>
          </td>
        </ng-container>

        <ng-container matColumnDef="partner">
          <th mat-header-cell *matHeaderCellDef> Partner </th>
          <td mat-cell *matCellDef="let element">
            <a *ngIf="element?.iddTraining.ofwca?.partner" class="default-link" [routerLink]="['/partnerzy/szczegoly', element?.iddTraining.ofwca?.partner?.uuid]">{{element?.iddTraining.ofwca?.partner?.shortName}}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="ofwcaAssetsRegional">
          <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) OFWCA </th>
          <td mat-cell *matCellDef="let element">
            {{element.iddTraining?.ofwca?.assetsRegional?.fullName}}
          </td>
        </ng-container>

        <ng-container matColumnDef="partnerAssetsRegional">
          <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
          <td mat-cell *matCellDef="let element">
            {{element.iddTraining.ofwca?.partner?.assetsRegionalFullName}}
          </td>
        </ng-container>

        <ng-container matColumnDef="chart">
          <th mat-header-cell *matHeaderCellDef> Postęp </th>
          <td mat-cell *matCellDef="let element">
            <app-idd-training-chart [iddTraining]="element.iddTraining" [chartType]="chartType" style="height: 30px; width: 250px; display: block"></app-idd-training-chart>
          </td>
        </ng-container>

        <ng-container matColumnDef="checkbox">
          <th mat-header-cell *matHeaderCellDef> Zapisz na Szkolenie IDD </th>
          <td mat-cell *matCellDef="let element">
            <mat-slide-toggle (change)="disableAboveLimit()" [formControl]="element.checkbox" label=""></mat-slide-toggle>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 20, 50]" [length]="totalData"></mat-paginator>
    </div>

    <div *ngIf="meetingObject.type.key === MEETING_TYPE_NEW_AGENT_TRAINING ">
      <table mat-table [dataSource]="ofwcaDataSourceActive">

        <ng-container matColumnDef="ofwca">
          <th mat-header-cell *matHeaderCellDef> OFWCA </th>
          <td mat-cell *matCellDef="let element">
            <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">
              {{element.ofwca?.fullName}}
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Status</th>
          <td mat-cell *matCellDef="let element">
            <button mat-raised-button [ngClass]="element.ofwca?.status.color + '-button'">{{element.ofwca?.status.name}}</button>
          </td>
        </ng-container>

        <ng-container matColumnDef="livingAddress">
          <th mat-header-cell *matHeaderCellDef> Adres zamieszkania </th>
          <td mat-cell *matCellDef="let element">
            <app-table-address [address]="$any(element.ofwca?.livingAddress)"></app-table-address>
          </td>
        </ng-container>

        <ng-container matColumnDef="facilityAddress">
          <th mat-header-cell *matHeaderCellDef> Adres placówki </th>
          <td mat-cell *matCellDef="let element">
            <app-table-address [address]="$any(element.ofwca?.facility?.address)"></app-table-address>
          </td>
        </ng-container>

        <ng-container matColumnDef="partner">
          <th mat-header-cell *matHeaderCellDef> Partner </th>
          <td mat-cell *matCellDef="let element">
            <a *ngIf="element.ofwca?.partner" class="default-link" [routerLink]="['/partnerzy/szczegoly', element.ofwca?.partner?.uuid]">{{element.ofwca.partner?.shortName}}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="ofwcaAssetsRegional">
          <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) OFWCA </th>
          <td mat-cell *matCellDef="let element">
            {{element.ofwca?.assetsRegional?.fullName}}
          </td>
        </ng-container>

        <ng-container matColumnDef="partnerAssetsRegional">
          <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
          <td mat-cell *matCellDef="let element">
            {{element.ofwca?.partner?.assetsRegionalFullName}}
          </td>
        </ng-container>


        <ng-container matColumnDef="checkbox">
          <th mat-header-cell *matHeaderCellDef> Zapisz na Szkolenie</th>
          <td mat-cell *matCellDef="let element">
            <mat-slide-toggle (change)="disableAboveLimitActive()" [formControl]="element.checkbox" label=""></mat-slide-toggle>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 20]" [length]="totalData"></mat-paginator>
    </div>

  </div>

</div>
